import { Link } from 'react-router-dom';
import { Layout } from '@/components/Layout';

export function NotFoundPage() {
  return (
    <Layout>
      <div className="text-center py-16">
        <h1 className="text-5xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Page Not Found
        </h2>
        <p className="text-gray-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700"
        >
          Go Home
        </Link>
      </div>
    </Layout>
  );
}
